import {
    addRecentAttachmentsForSingleRecepient,
    addOneRecentAttachmentForSingleRecepient,
    addRecentAttachmentsForMultipleRecepient,
    addRecentAttachmentForMultipleRecepient,
} from '../components/RecentAttachmentPills.locstring.json';
import loc, { format } from 'owa-localize';

export default function getAddNewAttachmentString(
    numberOfRecipients: number,
    numberOfAttachments: number,
    nameOfReceipient?: string
) {
    if (numberOfRecipients === 1 && nameOfReceipient) {
        if (numberOfAttachments === 1) {
            return format(loc(addOneRecentAttachmentForSingleRecepient), nameOfReceipient);
        } else {
            return format(loc(addRecentAttachmentsForSingleRecepient), nameOfReceipient);
        }
    } else {
        if (numberOfAttachments === 1) {
            return loc(addRecentAttachmentForMultipleRecepient);
        } else {
            return loc(addRecentAttachmentsForMultipleRecepient);
        }
    }
}
